export const SEARCH_FILTER_CATEGORIES = [
  { key: 'Accessories', th: 'สินค้าเสริมลุคชุดกีฬา' },
  {
    key: 'Bags & Bag Straps',
    th: 'กระเป๋า & สายสะพาย',
    id: 'Tas & Tali Tas',
  },
  { key: 'Beauty', th: 'เครื่องสำอาง', my: '', id: '' },
  { key: 'Dresses', th: 'เดรส' },
  {
    key: 'Hats And Hair',
    th: 'หมวกและเครื่องประดับผม',
    id: 'Hiasan Kepala',
  },
  { key: 'Jewelry', th: 'เครื่องประดับ', id: 'Perhiasan' },
  { key: 'Jumpsuits & Rompers', th: 'จัมพ์สูท' },
  { key: 'Outerwear', th: 'ชุดกีฬาสวมใส่ด้านนอก' },
  { key: 'Pants', th: 'กางเกงขายาว' },
  { key: 'Shoes', th: 'รองเท้า', id: '' },
  { key: 'Shorts', th: 'กางเกงขาสั้น' },
  { key: 'Skirts', th: 'กระโปรง' },
  { key: 'Tops', th: 'เสื้อท่อนบน', id: 'Atasan' },
]

export const SEARCH_FILTER_MAX_PRICE = {
  au: 300,
  id: 1600000,
  my: 600,
  sg: 200,
  th: 4000,
  us: 200,
  hk: 1500,
  mo: 1500,
  ph: 8000,
}

export const SEARCH_FILTER_COLORS = [
  { key: 'Red', th: 'แดง', reference: '#BC2131' },
  { key: 'Green', th: 'เขียว', reference: '#0B673A' },
  { key: 'Blue', th: 'น้ำเงิน', reference: '#2C3C8E' },
  { key: 'Pink', th: 'ชมพูอ่อน', reference: '#FF00FF' },
  { key: 'Purple', th: 'ม่วง', reference: '#790FCA' },
  { key: 'Orange', th: 'ส้ม', reference: '#EA8419' },
  { key: 'Brown', th: 'น้ำตาล', reference: '#8A5E3F' },
  { key: 'Black', th: 'ดำ', reference: '#000000' },
  { key: 'White', th: 'ขาว', reference: '#F1F2F2' },
  { key: 'Nude', th: 'นู้ด', reference: '#F9E4B7' },
  { key: 'Multi Color', th: 'หลากสี', reference: '#FFECEC' },
]

export const SEARCH_FILTER_SIZES = [
  { key: 'One Size', th: 'มีไซส์เดียว' },
  { key: 'S' },
  { key: 'M' },
  { key: 'L' },
  { key: 'XL' },
  { key: 'XXL' },
]

// Not in use currently, might never be used.
export const SEARCH_FILTER_BRANDS = []

export const SEARCH_SORT_OPTIONS = [
  {
    key: '', // popular
    label: {
      en: 'Popular',
      th: 'ยอดนิยม',
      id: 'Popularitas',
    },
  },
  {
    key: 'new_in',
    label: {
      en: 'New In',
      th: 'ของใหม่',
      id: 'Produk Terbaru',
    },
  },
  {
    key: 'price_desc',
    label: {
      en: 'Price: High to Low',
      th: 'ราคาสูงไปต่ำ',
      id: 'Harga : Tertinggi ke Terendah',
    },
  },
  {
    key: 'price_asc',
    label: {
      en: 'Price: Low to High',
      th: 'ราคาต่ำไปสูง',
      id: 'Harga : Terendah ke Tertinggin',
    },
  },
]
